import { gql, QueryHookOptions, useQuery } from '@apollo/client';
import { StudentsOrder, SubmitFormInput, User } from '../../dto';
import { ReqVars } from './common';

type Variables = {
  limit: number;
  offset: number;
  advisorIds?: number[];
  search?: string;
  order?: StudentsOrder;
  filter?: SubmitFormInput;
};
type Results = {
  students: {
    totalCount: number;
    students: User[];
  };
  studentsWithId?: User[];
};

const query = gql`
  query getStudents($limit: Int!, $offset: Int!, $advisorIds: [Int], $search: String, $order: StudentsOrder, $filter: SubmitFormInput) {
    students(searchParams: {limit: $limit, offset: $offset, advisorIds: $advisorIds, search: $search, order: $order, filter: $filter}) {
      totalCount
      students {
        id
        username
        firstName
        lastName
        phoneNumber
        advisor {
          id
          firstName
          lastName
          username
        }
        customProperties {
          id
          value
          type {
            id
            name
            fieldType
          }
        }
        emails {
          id
          email
          primary
        }
        unreadNotificationCount
      }
    }
  }
`;

export const useStudents = (options: ReqVars<QueryHookOptions<Results, Variables>>) => useQuery<Results, Variables>(query, options);
